/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */

define(['assets/js/modules/product/model/attributeModel'], function(AttributeModel) {
    return {
        /**
         * @param {CanvasRenderingContext2D} context
         * @param {LegendModel} legend
         * @param {number} shape
         * @param {number} arrowWidth
         * @param {number} width
         */
        render: function(context, legend, shape, arrowWidth, width) {
            context.textAlign = 'left';
            context.textBaseline = 'top';
            var x = 0;
            var y = 0;

            if (parseInt(shape) === AttributeModel.VALUE_SHAPE_CIRCLE) {
                var r = width / 2;
                var rads = 0;
                var offset = 0;

                if (legend.get('text').toUpperCase() === 'SAFE ZONE') {
                    rads = this.getRadianByDegree(220);
                    offset = 14;
                } else {
                    rads = this.getRadianByDegree(240);
                }

                x = r + r * Math.sin(rads);
                y = r + r * Math.cos(rads) + offset;

                context.fillText(legend.get('text'), x, y + 50);
                this.drawLine(context, x, y, x, y + 50);
            } else {
                if (legend.get('text').toUpperCase() === 'SAFE ZONE') {
                    x = 50;
                    y = legend.get('widthOffset') + 10;
                } else {
                    x = 25;
                    y = legend.get('widthOffset') + 50;
                }

                context.fillText(legend.get('text'), x, y);
                this.drawLine(context, x + 10, legend.get('widthOffset'), x + 10, y);
            }
        },

        /**
         * @param context
         * @param {number} fromX
         * @param {number} fromY
         * @param {number} toX
         * @param {number} toY
         */
        drawLine: function(context, fromX, fromY, toX, toY) {
            context.beginPath();
            context.moveTo(fromX, fromY);
            context.lineTo(toX, toY);
            context.stroke();
        },

        /**
         * @param {number} degree
         * @return {number}
         */
        getRadianByDegree: function(degree) {
            return degree * Math.PI / 180;
        }
    };
});
